import * as dotProp from 'dot-prop-immutable';

import { createReducer } from '@topconagriculture/frontend-utils';

import {
  createHerdManagementSystem,
  deleteHerdManagementSystem,
  editHerdManagementSystem,
  getHerdManagementSystem,
} from './hms.actions';
import { HerdManagementSystem } from './hms.type';

export type HerdManagementSystemState = HerdManagementSystem[];

const initialState: HerdManagementSystemState = [];

const herdManagementSystemReducer = createReducer(initialState, {
  [getHerdManagementSystem.done.type]: (state: HerdManagementSystemState, action) => action.payload.result,
  [createHerdManagementSystem.done.type]: (state: HerdManagementSystemState, action) => [
    ...state,
    action.payload.result,
  ],
  [editHerdManagementSystem.done.type]: (state: HerdManagementSystemState, action) => {
    const editedherdManagement = action.payload.result;
    const indexFound = state.findIndex((elem) => elem.id === editedherdManagement.id);
    return dotProp.set(state, indexFound, editedherdManagement);
  },
  [deleteHerdManagementSystem.done.type]: (state: HerdManagementSystemState, action) => {
    const deletedHerdId = action.payload.result;
    const indexFound = state.findIndex((elem) => elem.id === deletedHerdId);
    return dotProp.delete(state, indexFound);
  },
});

export default herdManagementSystemReducer;
